export default __webpack_public_path__ + "static/Mango-5fd8d9f24ce98a5168ecdaccd1e35176.jpeg";